import React, { useState } from "react";
import Layout from "../../Layout";
import { FaUserMd, FaHospital } from "react-icons/fa";
import demoServices from "../../Services/demoServices";
import moment from "moment";
import { message } from "antd";

const BookingDemo = () => {
  const [userType, setUserType] = useState("doctor"); // "doctor" or "hospital"
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    regNo: "",
    email: "",
    qualification: "",
    university: "",
    city: "",
    state: "",
    clinicName: "",
    address: "",
    contactNo: "",
    licenseNo: "",
    website: "",
    hospitalEmail: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const now = moment().format("YYYY-MM-DD HH:mm:ss");
    let payload = {};

    if (userType === "doctor") {
      payload = {
        city: formData.city,
        collegeName: formData.university,
        createdBy: formData.name || "Website",
        createdDate: now,
        doctorName: formData.name,
        email: formData.email,
        enquiryStatus: "NEW",
        mobileNo: formData.mobile,
        modifiedBy: formData.name || "Website",
        modifiedDate: now,
        qualification: formData.qualification,
        regNo: formData.regNo,
        state: formData.state,
        status: 1,
        userType: "DOCTOR",
      };
    } else {
      payload = {
        hospitalName: formData.clinicName,
        hospitalAddress: formData.address,
        mobileNo: formData.contactNo,
        email: formData.hospitalEmail,
        createdBy: "Website",
        createdDate: now,
        enquiryStatus: "NEW",
        modifiedBy: "Website",
        modifiedDate: now,
        licenseNo: formData.licenseNo,
        websiteUrl: formData.website,
        status: 1,
        userType: "HOSPITAL",
      };
    }

    try {
      const response = await demoServices.saveDemoEnquiry(payload);
      if (response.data) {
        message.success("Demo Booking Request Sent Successfully!");
        setFormData({
          name: "",
          mobile: "",
          regNo: "",
          email: "",
          qualification: "",
          university: "",
          city: "",
          state: "",
          clinicName: "",
          address: "",
          contactNo: "",
          licenseNo: "",
          website: "",
          hospitalEmail: "",
        });
      }
    } catch (error) {
      console.error("Error submitting demo booking:", error);
      message.error("Failed to send demo booking request. Please try again.");
    }
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-[#f0f9fa] to-[#e0f2f1] py-12 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
        <div className="max-w-4xl w-full">
          <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-2xl overflow-hidden border border-white/20">
            <div className="md:flex">
              {/* Left Side - Info */}
              <div className="md:w-1/3 bg-[#189FAA] p-8 text-white flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-4">Book a Demo</h2>
                <p className="text-[#e0f2f1] mb-8">
                  Experience the future of healthcare management. One of our experts will reach out to you shortly.
                </p>

              </div>

              {/* Right Side - Form */}
              <div className="md:w-2/3 p-8">
                <div className="flex justify-center mb-8">
                  <div className="bg-gray-100 p-1 rounded-xl flex">
                    <button
                      onClick={() => setUserType("doctor")}
                      className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${userType === "doctor"
                          ? "bg-[#189FAA] text-white shadow-md"
                          : "text-gray-500 hover:bg-gray-200"
                        }`}
                    >
                      Doctor
                    </button>
                    <button
                      onClick={() => setUserType("hospital")}
                      className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${userType === "hospital"
                          ? "bg-[#189FAA] text-white shadow-md"
                          : "text-gray-500 hover:bg-gray-200"
                        }`}
                    >
                      Hospital / Clinic
                    </button>
                  </div>
                </div>

                <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-x-6 gap-y-7">
                  {userType === "doctor" ? (
                    <>
                      {/* Name Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Name <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <input
                          required
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Dr. John Doe"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Mobile Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Mobile <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <input
                          required
                          type="tel"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          placeholder="10-digit number"
                          maxLength={10}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Reg No Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Reg No <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <input
                          required
                          type="text"
                          name="regNo"
                          value={formData.regNo}
                          onChange={handleChange}
                          placeholder="Registration Number"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Email Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Email
                        </span>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="john@example.com"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Qualification Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Qualification
                        </span>
                        <input
                          type="text"
                          name="qualification"
                          value={formData.qualification}
                          onChange={handleChange}
                          placeholder="MBBS, MD"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* University Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          University or College
                        </span>
                        <input
                          type="text"
                          name="university"
                          value={formData.university}
                          onChange={handleChange}
                          placeholder="Medical University Name"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* City Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          City
                        </span>
                        <input
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="Your City"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* State Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          State
                        </span>
                        <input
                          type="text"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          placeholder="Your State"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {/* Clinic Name Field */}
                      <div className="relative w-full col-span-2">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Clinic or Hospital Name <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <input
                          required
                          type="text"
                          name="clinicName"
                          value={formData.clinicName}
                          onChange={handleChange}
                          placeholder="Healthcare Center Name"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Address Field */}
                      <div className="relative w-full col-span-2">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Address <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <textarea
                          required
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          placeholder="Complete Address"
                          rows="2"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white"
                        ></textarea>
                      </div>

                      {/* Contact No Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Contact No <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <input
                          required
                          type="tel"
                          name="contactNo"
                          value={formData.contactNo}
                          onChange={handleChange}
                          placeholder="10-digit number"
                          maxLength={10}
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* License No Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          License No <span style={{ color: "#FF000F" }}>*</span>
                        </span>
                        <input
                          required
                          type="text"
                          name="licenseNo"
                          value={formData.licenseNo}
                          onChange={handleChange}
                          placeholder="Medical License Number"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Website Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Website Link
                        </span>
                        <input
                          type="url"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          placeholder="https://www.clinic.com"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>

                      {/* Hospital Email Field */}
                      <div className="relative w-full">
                        <span className="absolute -top-2 text-xs font-semibold z-10 left-3 bg-white px-1 text-gray-700">
                          Email
                        </span>
                        <input
                          type="email"
                          name="hospitalEmail"
                          value={formData.hospitalEmail}
                          onChange={handleChange}
                          placeholder="clinic@example.com"
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none text-xs font-medium font-sans text-[#232323] focus:border-[#189FAA] bg-white h-11"
                        />
                      </div>
                    </>
                  )}
                  <div className="col-span-2 pt-4">
                    <button
                      type="submit"
                      className="w-full bg-[#189FAA] text-white font-bold py-4 rounded-xl shadow-lg hover:bg-[#158994] active:transform active:scale-[0.98] transition-all duration-200 text-lg"
                    >
                      Book Free Demo
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BookingDemo;
